import React from "react";

function FacebookIcon({
  startColor = "#004d00",
  endColor = "#00e600",
  size = "w-8 h-8",
}) {
  const gradientId = `shareIconGradient-${startColor}-${endColor}`;

  return (
    <svg
      className={size} // Use template literals to combine classes
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={startColor} />
          <stop offset="100%" stopColor={endColor} />
        </linearGradient>
      </defs>
      <path
        fill={`url(#${gradientId})`}
        d="M448,512h-87.999c-22.094,0-39.999-17.922-39.999-40V360.001
c0-22.094,17.905-39.999,39.999-39.999h12.922c8.32,0,16.844-6.656,19.062-15.031l8.484-31.953
c2.484-9.312-2.812-17.023-11.852-17.023h-28.617c-22.094,0-39.999-17.902-39.999-39.988v-16c0-22.102,17.905-40.007,39.999-40.007
h24.008c8.82,0,16-7.156,16-16v-32.004c0-8.828-7.18-16.004-16-16.004h-48.008c-44.187,0-79.991,35.828-79.991,80.011v40.004
c0,22.085-17.922,39.988-40.003,39.988h-7.625c-9.039,0-16.379,7.711-16.379,17.023v31.953c0,8.375,6.746,15.031,15.07,15.031h8.934
c22.082,0,40.003,17.905,40.003,39.999V472c0,22.078-17.922,40-40.003,40h-8c-8.844,0-16.004-7.172-16.004-16
c0-8.844,7.16-16,16.004-16c8.824,0,16-7.172,16-16v-95.999c0-8.844-7.175-16-16-16H197.51c-20.719,0-37.511-16.578-37.511-37.577
v-47.922c0-23.156,18.371-42.512,41.027-42.512h6.98c8.824,0,16-7.16,16-15.984v-40.004c0-57.441,46.559-103.995,103.995-103.995
h64.008c22.086,0,39.984,17.902,39.984,39.988v48.004c0,22.085-17.898,40.003-39.984,40.003h-24.008h-16v16.004
c0,8.824,7.156,15.984,16,15.984h29.969c22.672,0,37.398,19.355,33.062,42.512l-8.992,47.922
c-3.93,20.999-23.82,37.577-44.539,37.577h-9.5c-8.844,0-16,7.156-16,16V464c0,8.828,7.156,16,16,16H448c17.672,0,32-14.328,32-32
V64.007c0-17.688-14.328-32.003-32-32.003H64.007c-17.672,0-32.003,14.316-32.003,32.003V448c0,17.672,14.332,32,32.003,32h16
c8.828,0,16.003,7.156,16.003,16c0,8.828-7.175,16-16.003,16h-16C28.668,512,0,483.344,0,448V64.007C0,28.648,28.668,0,64.007,0H448
c35.359,0,64,28.648,64,64.007V448C512,483.344,483.359,512,448,512L448,512z M143.999,480c8.844,0,16,7.156,16,16
c0,8.828-7.156,16-16,16c-8.828,0-16.004-7.172-16.004-16C127.995,487.156,135.171,480,143.999,480L143.999,480z"
      />
    </svg>
  );
}

export default FacebookIcon;
